module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av600-804b163cdf719f91ce2c66ceab5ad7f5.jpg";